<template>
    <div
        id="events-container-id"
        :class="['map-event-container-wrapper', {'map-event-container-wrapper-hidden': !getMapEventsViewOpen}]"
    >
        <div class="py-2 map-events-title" @click.stop="onTitleClick">
            {{ $t('dashboard.events.title') }}
        </div>
        <div
            v-if="!getMapEventsViewOpen"
            class="event-container-open-marker"
            @click.stop="onTitleClick"
        >
            <div>
                <SvgIcon name="chevron-up" :width="6"/>
            </div>
        </div>
        <div
            v-if="getMapEventsViewOpen"
            class="event-container-open-marker"
            @click.stop="onTitleClick"
        >
            <div>
                <SvgIcon name="chevron-down" :width="6"/>
            </div>
        </div>
        <div class="border-bottom border-color-blue mb-1"></div>
        <div class="event-content-wrapper">
            <div class="py-2 px-3 text-center dt-block">
                <b-dropdown
                    variant="link"
                    toggle-class="text-decoration-none outline-none"
                    class="mx-1 my-0 br-border"
                    no-caret
                >
                    <template v-slot:button-content>
                        <div class="d-flex justify-content-between">
                            <span class="text-body">
                                {{stateSelected === 'all' ? $t(`dashboard.events.attribute-select.all`) : attrTranslateSelected}}
                            </span>
                            <span>
                                 <SvgIcon name="chevron-down" direction="up"/>
                            </span>
                        </div>
                    </template>

                    <b-dropdown-item
                        event="hover"
                        :key="`field-all`"
                        @click.stop="onAttributeOptionClick({value: 'all', label: 'all'})"
                    >
                        {{$t('dashboard.events.attribute-select.all')}}
                    </b-dropdown-item>
                    <b-dropdown-item
                        event="hover"
                        v-for="(field, index) in attributeOptions"
                        :key="`field-${index}`"
                        @click.stop="onAttributeOptionClick(field)"
                    >
                        {{field.label}}
                    </b-dropdown-item>
                </b-dropdown>
            </div>
<!--            <div class="py-2 pl-2 criteria-checkbox-wrapper">-->
<!--                <CheckboxList-->
<!--                    :options="criteriaOptions"-->
<!--                    :title="'dashboard.events.checklist-title'"-->
<!--                    :criteriaSelected="criteriaSelected"-->
<!--                    @onChange="onCriteriaChange"-->
<!--                />-->
<!--            </div>-->
            <div class="map-events-container">
                <div v-for="(event, i) of filteredAlarms" :key="i">
                    <MapEvent :event="event" @show-on-map="showEventOnMap"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    // components
    import MapEvent from './MapEvent';
    // import CheckboxList from '../shared/CheckboxList';
    import SvgIcon from '../shared/SvgIcon';
    // vuex
    import {mapGetters, mapActions} from 'vuex';
    import {
        SET_MAP_EVENTS_VIEW_OPEN,
        SET_MAP_COORDINATES,
        SET_MAP_ZOOM,
        SET_ACTIVE_STATION
    } from "../../store/actions/dashboard";
    // modules
    import {isEmpty} from 'lodash';
    // mixins
    import SafeTranslateMixin from "../../mixins/SafeTranslateMixin";
    // import { parsedDate } from '@/utils/common'

    export default {
        name: 'EventsContainer',
        components: {
            MapEvent,
            // CheckboxList,
            SvgIcon,
        },
        mixins: [SafeTranslateMixin],
        data: () => ({
            // criteriaOptions: [
            //     {text: 'dashboard.events.checklist-values.all', value: 'all'},
            //     {text: 'dashboard.events.checklist-values.last24Hours', value: 'time-span'},
            // ],
            criteriaSelected: 'all',
            stateSelected: 'all',
            attrTranslateSelected: 'all'
        }),
        computed: {
            ...mapGetters(['getAlarms', 'getMapEventsViewOpen', 'getPsData']),

            filteredAlarms() {
                const result = [];
                if (isEmpty(this.getAlarms)) return result;
                // Filter by criteria
                if (
                    this.criteriaSelected === 'all' ||
                    (isEmpty(this.criteriaSelected) && this.criteriaSelected !== 0)
                ) {
                    result.push(...this.getAlarms);
                }
                // else {
                //     result.push(...this.onFilterByTyme());
                // }

                // Filter by attribute
                if (this.stateSelected === 'all') return result;

                return result.filter(e => {
                    return (e.state === this.stateSelected) || (e.attrib === this.stateSelected)
                });
            },
            attributeOptions() {
                if (isEmpty(this.getAlarms)) return [];

                let attributesSet = new Set(this.getAlarms.map(e => e.attrib));
                attributesSet = Array.from(attributesSet)
                    .map(e => ({
                        label: this.safeTranslateValue('sensors', e),
                        value: e
                    }));

                // prepend static options
                attributesSet.unshift(
                    {label: this.$i18n.t('dashboard.warning-all'), value: 2},
                    {label: this.$i18n.t('dashboard.danger-all'), value: 0}
                )

                return attributesSet;
            }
        },
        methods: {
            ...mapActions([
                SET_MAP_EVENTS_VIEW_OPEN,
                SET_MAP_COORDINATES,
                SET_MAP_ZOOM,
                SET_ACTIVE_STATION
            ]),
            onCriteriaChange(value) {
                this.criteriaSelected = value;
            },
            onTitleClick() {
                this.SET_MAP_EVENTS_VIEW_OPEN(!this.getMapEventsViewOpen);
            },
            onAttributeOptionClick({value, label}) {
                this.attrTranslateSelected = label;
                this.stateSelected = value;
            },
            // onFilterByTyme() {
            //     // Create a new date and get the dat time bewfor 24 hours
            //     const dateTimeBarrier = new Date();
            //     const dateTimeBarrierMinutes = 1440;
            //
            //     dateTimeBarrier.setMinutes(
            //         dateTimeBarrier.getMinutes() - dateTimeBarrierMinutes
            //     );
            //     // filter the alarms which are triggered in the last 24 hours
            //     return this.getAlarms
            //         .filter(({date}) => parsedDate(date) > dateTimeBarrier);
            // }
            showEventOnMap(event) {
                const psStations = this.getPsData.PS_stations;
                for(let index = 0; index < psStations.length; index++) {
                    if (psStations[index][0] === event.devId && psStations[index][1] === event.index) {
                        const [,,lat, lng] = psStations[index];
                        this.SET_MAP_COORDINATES({lat, lng});
                        this.SET_MAP_ZOOM(11);
                        this.SET_ACTIVE_STATION(psStations[index]);
                        break;
                    }
                }
            }
        },
    }
</script>

<style lang="scss" scoped>
    @import '../../assets/scss/variables';

    .map-event-container-wrapper {
        position: absolute;
        bottom: 0;
        left: 0;
        display: block;
        background: $whiteColor 0 0 no-repeat padding-box;
        box-shadow: 0 0 10px $shadowColor;
        border-radius: 0 5px 0 0;
        width: 320px;
        height: 98%;
        z-index: 1;
        font-family: $font-family-sans-serif;
        color: $darkGray2;
        transition: height 0.25s ease-in;
        padding-top: 5px;

        &.map-event-container-wrapper-hidden {
            height: 34px;
            transition: height 0.25s ease-out;
        }
    }

    .event-container-open-marker {
        background: transparent;
        height: 20px;
        width: 100%;
        position: absolute;
        top: -8px;

        & > div {
            cursor: pointer;
            border-radius: 25px 25px 0px 0px;
            background: $whiteColor;
            color: #6299eb;
            height: 20px;
            width: 25px;
            line-height: 15px;
            margin: auto;
            vertical-align: top;
            text-align: center;
        }
    }

    .map-events-title {
        cursor: pointer;
        text-align: center;
        font-family: $font-family-sans-serif;
        font-weight: $font-weight-normal;
        font-size: $font-size-base;
        line-height: $font-size-base;
        letter-spacing: 0;
        color: $events-title-color;
        opacity: 1;
    }

    .border-color-blue {
        border-bottom-color: $events-border-color !important;
    }

    .event-content-wrapper {
        height: calc(100% - 34px); // 34 is height of the title container
        overflow: hidden;

        .criteria-checkbox-wrapper {
            margin: auto;
        }

        .map-events-container {
            height: calc(100% - 50px);
            overflow-y: scroll;
        }
    }

    @media (max-width: 768px) {
        .map-event-container-wrapper {
            width: 100%;
        }
    }


</style>
